//
// components/c-js-expandable.js
//
// A nestable vertical expanding component (up to 3 expandable deep)
//

import {throttle} from 'throttle-debounce';

import * as collection_listener from '../helpers/collection-listener';
import outer_height from '../helpers/outer-height';
import find_ancestor from '../helpers/find-ancestor';


const e = {};
const metrics = {};


// get the height of the content
function get_height(el) {
  const [this_content_inner] = el.getElementsByClassName('c-js-expandable__content-inner');
  metrics.height = outer_height(this_content_inner);
  return metrics.height;
}

// set th height to the value of the above
function set_height(el) {
  const [this_inner] = el.getElementsByClassName('c-js-expandable__inner');
  this_inner.style.maxHeight = `${metrics.height}px`;
}

function set_height_zero(el) {
  const [this_inner] = el.getElementsByClassName('c-js-expandable__inner');
  this_inner.style.maxHeight = 0;
}

// set the height to 0
function set_height_zero_all() {
  e.expandable_inner.forEach((el) => {
    el.style.maxHeight = 0;
  });
}

function expand_parent(el, decendentHeight) {
  const parent = el.parentNode.closest('.c-js-expandable');
  const [parent_inner] = parent.getElementsByClassName('c-js-expandable__inner');
  const parent_inner_height = outer_height(parent);
  parent_inner.style.maxHeight = `${parseInt(decendentHeight, 10) + parent_inner_height}px`;
}

// apply the height to the container
function expand_selected(el) {
  const height = get_height(el);
  const [this_opener] = el.getElementsByClassName('c-js-expandable__opener');
  const [this_indicator_text] = el.getElementsByClassName('c-js-expandable__opener-text');
  const parent = find_ancestor(el, 'c-js-expandable');

  set_height(el);
  el.classList.add('c-js-expandable--active');

  this_opener.classList.add('c-js-expandable__opener--active');

  if (this_indicator_text) {
    this_indicator_text.innerHTML = 'Hide';
  }

  if (parent && parent !== el && parent.classList.contains('c-js-expandable--active')) {
    expand_parent(el, height);
  }
}

// remove the height from the container
function collapse_selected(el) {
  el.classList.remove('c-js-expandable--active');
  const [this_opener] = el.getElementsByClassName('c-js-expandable__opener');
  const [this_indicator_text] = el.getElementsByClassName('c-js-expandable__opener-text');

  if (this_indicator_text) {
    this_indicator_text.innerHTML = 'Expand';
  }

  set_height_zero(el);
  this_opener.classList.remove('c-js-expandable__opener--active');
}

// collapse all
function collapse_all() {
  set_height_zero_all();
  e.expandable.forEach(el => el.classList.remove('c-js-expandable--active'));
  e.expandable_opener.forEach(el => el.classList.remove('c-js-expandable__opener--active'));
}

// click__cb
function cb_click(ev) {
  const this_expandable = find_ancestor(ev.currentTarget, 'c-js-expandable');

  if (this_expandable.classList.contains('c-js-expandable--active')) {
    collapse_selected(this_expandable);
  }
  else {
    expand_selected(this_expandable);
  }
}


function on_window_resize() {
  if (window.innerWidth !== metrics.current_window_width) {
    collapse_all();
    metrics.current_window_width = window.innerWidth;
  }
}


function init() {
  e.expandable = Array.from(document.getElementsByClassName('c-js-expandable'));
  if (e.expandable.length === 0) {
    return;
  }

  e.expandable_opener = Array.from(document.getElementsByClassName('c-js-expandable__opener'));
  e.expandable_inner = Array.from(document.getElementsByClassName('c-js-expandable__inner'));

  metrics.current_window_width = window.innerWidth;

  collection_listener.add(e.expandable_opener, 'click', cb_click);
  window.addEventListener('resize', throttle(500, on_window_resize));
}

init();

export {
  collapse_all,
};

